'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _findComponent = require('@brandwatch/axiom-utils/dist/findComponent');

var _findComponent2 = _interopRequireDefault(_findComponent);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _popper = require('popper.js');

var _popper2 = _interopRequireDefault(_popper);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Portal = require('../Portal/Portal');

var _Portal2 = _interopRequireDefault(_Portal);

var _PositionSource = require('./PositionSource');

var _PositionTarget = require('./PositionTarget');

var _utils = require('./_utils');

require('./Position.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-find-dom-node */
var Position = function (_Component) {
  _inherits(Position, _Component);

  function Position(props) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props));

    _this.handleOnCreate = _this.handleOnCreate.bind(_this);
    _this.handleOnUpdate = _this.handleOnUpdate.bind(_this);
    _this.state = {
      placement: (0, _utils.positionToPlacement)(props.position, props.offset)
    };
    return _this;
  }

  _createClass(Position, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this._content) {
        this._popper = this.createPopper();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          enabled = _props.enabled,
          isVisible = _props.isVisible,
          position = _props.position,
          offset = _props.offset;


      if (enabled && isVisible) {
        if (!this._popper) {
          this._popper = this.createPopper();
        } else {
          this._popper.options.placement = (0, _utils.positionToPlacement)(position, offset);
          this._popper.update();
        }
      } else if (this._popper) {
        this.destroyPopper();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroyPopper();
    }
  }, {
    key: 'createPopper',
    value: function createPopper() {
      var _props2 = this.props,
          boundariesElement = _props2.boundariesElement,
          flip = _props2.flip,
          showArrow = _props2.showArrow,
          reference = _props2.reference;
      var placement = this.state.placement;


      return new _popper2.default(reference || this._target, this._content, {
        onCreate: this.handleOnCreate,
        onUpdate: this.handleOnUpdate,
        placement: placement,
        modifiers: {
          arrow: {
            enabled: showArrow,
            element: this._arrow
          },
          flip: {
            behavior: (0, _utils.getPlacementFlipOrder)(placement, flip)
          },
          inner: {
            enabled: false
          },
          offset: {
            enabled: false
          },
          preventOverflow: {
            boundariesElement: boundariesElement
          }
        }
      });
    }
  }, {
    key: 'destroyPopper',
    value: function destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }

      delete this._popper;
      delete this._arrow;
      delete this._content;

      var placement = (0, _utils.positionToPlacement)(this.props.position, this.props.offset);
      if (placement !== this.state.placement) {
        this.setState({ placement: placement });
      }
    }
  }, {
    key: 'handleOnCreate',
    value: function handleOnCreate(popper) {
      var onPositionChange = this.props.onPositionChange;


      this.handleOnUpdate(popper);

      if (onPositionChange) {
        onPositionChange(popper.placement);
      }
    }
  }, {
    key: 'handleOnUpdate',
    value: function handleOnUpdate(_ref) {
      var placement = _ref.placement;
      var onPositionChange = this.props.onPositionChange;
      var statePlacement = this.state.placement;


      if (statePlacement !== placement) {
        this.setState({ placement: placement });

        if (onPositionChange) {
          onPositionChange(placement);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          children = _props3.children,
          className = _props3.className,
          enabled = _props3.enabled,
          isVisible = _props3.isVisible,
          onMaskClick = _props3.onMaskClick,
          showArrow = _props3.showArrow,
          reference = _props3.reference,
          rest = _objectWithoutProperties(_props3, ['children', 'className', 'enabled', 'isVisible', 'onMaskClick', 'showArrow', 'reference']);

      var placement = this.state.placement;

      var _placementToPosition = (0, _utils.placementToPosition)(placement),
          _placementToPosition2 = _slicedToArray(_placementToPosition, 1),
          position = _placementToPosition2[0];

      var classes = (0, _classnames2.default)('ax-position', {
        'ax-position--arrow': showArrow
      }, className);

      var props = (0, _lodash2.default)(rest, ['flip', 'offset', 'position', 'onPositionChange']);

      return [!reference && (0, _react.cloneElement)((0, _findComponent2.default)(children, _PositionTarget.PositionTargetRef), {
        ref: function ref(target) {
          return _this2._target = _reactDom2.default.findDOMNode(target);
        }
      }), enabled && isVisible ? _react2.default.createElement(
        _Portal2.default,
        _extends({}, props, { key: 'portal' }),
        _react2.default.createElement(
          'div',
          null,
          onMaskClick && _react2.default.createElement('div', { className: 'ax-position__mask', onClick: onMaskClick }),
          _react2.default.createElement(
            'div',
            { className: classes, ref: function ref(el) {
                return _this2._content = el;
              } },
            (0, _react.cloneElement)((0, _findComponent2.default)(children, _PositionSource.PositionSourceRef), {
              arrowRef: showArrow ? function (arrow) {
                return _this2._arrow = _reactDom2.default.findDOMNode(arrow);
              } : undefined,
              position: position
            })
          )
        )
      ) : null];
    }
  }]);

  return Position;
}(_react.Component);

Position.propTypes = {
  /**
   * Allows the boundary element for the positioning to be set.
   */
  boundariesElement: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.oneOf(['scrollParent', 'viewport', 'window'])]),
  /**
   * Children inside Position this should contain all of and
   * only PositionSource and PositionTarget or just a PositionSource
   * in the case of a given reference!
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.array]).isRequired,
  /** Class name to be appended to the element */
  className: _propTypes2.default.string,
  /**
   * Adds control to conditionally enable or disable the positioning logic.
   * Must be true for isVisible to take effect.
   */
  enabled: _propTypes2.default.bool,
  /** Adds control of content flipping fallbacks. */
  flip: _propTypes2.default.oneOf(['anticlockwise', 'clockwise', 'mirror']),
  /** Toggles the visibility of the PositionSource */
  isVisible: _propTypes2.default.bool.isRequired,
  /** Controls the starting offset of the content */
  offset: _propTypes2.default.oneOf(['start', 'middle', 'end']),
  /**
   * When provided a mask will be placed behind PositionSource, where this
   * function is called when clicked.
   */
  onMaskClick: _propTypes2.default.func,
  /**
   * Optional handler that is called, with the new position, when PositionSource
   * has been positioned.
   */
  onPositionChange: _propTypes2.default.func,
  /**
   * Controls the starting position around PositionTarget in which the
   * PositionSource will attempt to be placed. If that position is not available
   * due to collision, it will be placed according to the flip behaviour  until
   * a valid position is found.
   */
  position: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * If Position should be attached to an element outside of the React context,
   * either a HTMLElement reference or a Popper.js compatible referenceObject
   * (see https://popper.js.org/popper-documentation.html#referenceObject) can
   * be passed in.
   */
  reference: _propTypes2.default.object,
  /** Toggle that allows the arrow of the Context component to be hidden */
  showArrow: _propTypes2.default.bool
};
Position.defaultProps = {
  boundariesElement: 'viewport',
  enabled: true,
  flip: 'clockwise',
  offset: 'middle',
  position: 'top',
  showArrow: false
};
exports.default = Position;